import React from "react";

const ThreeDotsLoader = () => {
  return <span className="loader"></span>;
};

export default ThreeDotsLoader;
